import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byProp',
  pure: false,
  standalone: false
})
@Injectable()
export class ByPropPipe implements PipeTransform {
  public transform(items: any[], prop: any, value: string): any[] {
    if (prop && value && value.trim()) {
      const filteredArr = items.filter((item) => item[prop].toLowerCase().indexOf(value.toLowerCase()) !== -1);
      return filteredArr;
    }
    return items;
  }
}
